var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"config":_vm.InstantConfig,"pagination":_vm.Instantpagination,"tableData":_vm.InstantData},on:{"click":_vm.onButtonClick,"refresh":_vm.loadData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }